import { Typography } from "@datamole/wds-component-typography";
import { Link } from "react-router-dom";

import styles from "@/pages/error-page/error-page.module.css";
import { routes } from "@/routes";

export const ErrorPage = () => {
    return (
        <div className={styles.error_page}>
            <Typography as="h1" variant="5xl" weight="bold">
                Something went wrong :(
            </Typography>
            <Link to={routes.home.path}>Go to homepage</Link>
        </div>
    );
};
